const initialState = {
    currentImg: []

};
const advViewReducer = (state = initialState, action) => {
    switch(action.type) {
        case "SET_CURRENT_IMG":
            console.log(action.img)
            return {
                ...state,
                currentImg: action.img
            };
        default:
            return state
    };
};

export default advViewReducer;


export const setCurrentImg = img => ({type: "SET_CURRENT_IMG", img})


